import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { CoreStrength } from "./components/CoreStrength";
import { WhyTrustUs } from "./components/WhyTrustUs";
import { GlobalReach } from "./components/GlobalReach";
import { Leadership } from "./components/Leadership";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-white antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <CoreStrength />
        <WhyTrustUs />
        <GlobalReach />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
